import { render } from "./InspectionPlanProductDetail.vue?vue&type=template&id=0527a6b0"
import script from "./InspectionPlanProductDetail.vue?vue&type=script&lang=js"
export * from "./InspectionPlanProductDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__